import React from "react";

const Application = ({styles}) => {
  return (
    <div className={`application mt-33 ${styles}`}>
      <div className="container">
        <div className="row">
          <div className="col-md-8 p-5">
            <h4>
              اپلیکیشن ثبت آگهی
              <span> صنعتبان </span>
            </h4>
            <p>
              برای دانلود اپلیکیشن می توانید شماره خود را اینجا وارد نمایید.
            </p>
            <div className="markets">
              <a>
                <img src={require("../../Assets/images/bazzar.png")} />
              </a>
              <a>
                <img src={require("../../Assets/images/google.png")} />
              </a>
              <a>
                <img src={require("../../Assets/images/myket.png")} />
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="mockup">
              <img src={require("../../Assets/images/mockup.png")} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Application;
